











































import {defineComponent} from '@vue/composition-api';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';
import ChemicalNotationInput from '@/chemical-equations/components/ChemicalNotationInput.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';

export default defineComponent({
  name: 'ChemCPP1220LPostLab22Unknown',
  components: {CalculationInput, ChemicalNotationInput},
  mixins: [DynamicQuestionMixin()],
  data() {
    const inputs: Record<string, any> = {};
    for (let u = 1; u <= 8; u++) {
      inputs[`countIons${u}`] = 0;
      for (let i = 1; i <= 6; i++) {
        inputs[`ion${u}_${i}`] = null;
      }
    }
    return {inputs};
  },
  methods: {
    displayedCount(u: number): number {
      const c = Number(this.inputs[`countIons${u}`]) || 0;
      return Math.min(6, Math.max(0, c));
    },
  },
});
